import axios from "../lib/axios";
import {MASTER_CATEGORIES_FIND_MANY } from "../lib/endpoints/category";
import { SuppliesCategoryProduct } from "../models/suppliesCategoryProduct";


export const getAllMasterCategory=async ():Promise<SuppliesCategoryProduct[]>=>{
  const res=await axios.post(MASTER_CATEGORIES_FIND_MANY);

  return res?.data;
}

export const getMasterCategory=async (divisionId:string):Promise<SuppliesCategoryProduct[]>=>{
    const res=await axios.post(MASTER_CATEGORIES_FIND_MANY,{
        "filter": {
          "supplies_division_name_id": divisionId,

        }
      });

    return res?.data;
}